import { documentExpirationDatesApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DOCUMENT_EXPIRATION_DATES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/expirationDates`,
  {
    GET_EXPIRATION_DATES: 'GET_EXPIRATION_DATES',
    CREATE_DOCUMENT_EXPIRATION_DATE: 'CREATE_DOCUMENT_EXPIRATION_DATE',
    CREATE_DEFAULT_DOCUMENT_EXPIRATION_DATE: 'CREATE_DEFAULT_DOCUMENT_EXPIRATION_DATE',
    EDIT_DOCUMENT_EXPIRATION_DATE: 'EDIT_DOCUMENT_EXPIRATION_DATE',
    DELETE_DOCUMENT_EXPIRATION_DATE: 'DELETE_DOCUMENT_EXPIRATION_DATE',
  },
);
export const getDocumentExpirationDatesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentExpirationDatesApi.getDocumentExpirationDates(params);

  const documentExpirationDatesMissedIds = data?.documentExpirationDates?.map(item =>
    item.id ? item : { ...item, id: crypto.randomUUID(), isTempId: true },
  );

  return dispatch({
    type: DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.GET_EXPIRATION_DATES,
    payload: documentExpirationDatesMissedIds,
  });
});

export const createDocumentExpirationDateAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await documentExpirationDatesApi.createDocumentExpirationDate(params);

    if (params.isDefaultDocumentExpirationDateToCreate) {
      return dispatch({
        type: DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.CREATE_DEFAULT_DOCUMENT_EXPIRATION_DATE,
        payload: {
          idToReplace: params.id,
          ...data,
        },
      });
    }

    return dispatch({
      type: DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.CREATE_DOCUMENT_EXPIRATION_DATE,
      payload: data,
    });
  },
);

export const createDefaultDocumentExpirationDateAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await documentExpirationDatesApi.createDocumentExpirationDate(params);

    return dispatch({
      type: DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.CREATE_DEFAULT_DOCUMENT_EXPIRATION_DATE,
      payload: {
        idToReplace: params.id,
        ...data,
      },
    });
  },
);

export const editDocumentExpirationDateAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentExpirationDatesApi.editDocumentExpirationDate(params);

  return dispatch({
    type: DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.EDIT_DOCUMENT_EXPIRATION_DATE,
    payload: data,
  });
});

export const deleteDocumentExpirationDateAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await documentExpirationDatesApi.deleteDocumentExpirationDate(params);

    return dispatch({
      type: DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.DELETE_DOCUMENT_EXPIRATION_DATE,
      payload: { ...data, id: params.id },
    });
  },
);
